import React, { useState } from 'react';
import { AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';

import Actions from './props/Actions';
import { AttachmentList } from '../../../components/Attachments';

const Meeting = (props) => {
    let { activity, activityData, onUpdateActivity } = props;
    let [hovered, setHovered] = useState(false);

    return (
        <>
            <AccordionItemHeading>
                <AccordionItemButton>
                    <div className="activity-card meeting-card">
                        <div className="activity-header">
                            <div className="activity-type-info">
                                <div className="activity-icon meeting-icon">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19Z" fill="currentColor" />
                                        <path d="M7 10H17V12H7V10ZM7 14H17V16H7V14Z" fill="currentColor" />
                                        <path d="M16 1H18V5H16V1ZM6 1H8V5H6V1Z" fill="currentColor" />
                                    </svg>
                                </div>
                                <div className="activity-details">
                                    <div className="activity-title meeting-card-title">
                                        <span className="meeting-card-subject">
                                            {activity?.title || 'Meeting'}
                                        </span>
                                        <span className="meeting-card-tag">meeting</span>
                                    </div>
                                    <div className="activity-meta">
                                        <span className="created-by">by {activityData?.createdBy}</span>
                                        {activity?.duration && (
                                            <span className="meeting-duration">{activity.duration}min</span>
                                        )}
                                        {activityData?.assignedTo && activityData.assignedTo !== activityData.createdBy && (
                                            <span className="assigned-to">assigned to {activityData.assignedTo}</span>
                                        )}
                                    </div>
                                </div>
                            </div>



                            <div className="activity-actions" onClick={(e) => e.stopPropagation()}>
                                <Actions {...props} />
                                <span className="activity-time">{activityData?.dueDate || activityData?.createdAt}</span>
                            </div>
                        </div>

                    </div>
                </AccordionItemButton>
            </AccordionItemHeading>

            <AccordionItemPanel>
                <div className="activity-card-body meeting-card-body">
                    {activity?.meetingLink && (
                        <div className="meeting-link">
                            <strong>Meeting Link:</strong>
                            <a href={activity.meetingLink} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
                                Join Meeting
                            </a>
                        </div>
                    )}

                    {activity?.description && (
                        <div className="activity-description" dangerouslySetInnerHTML={{ __html: activity.description }}></div>
                    )}

                    {activity?.outcome && (
                        <div className="meeting-outcome">
                            <strong>Outcome:</strong> {activity.outcome}
                        </div>
                    )}

                    {activity['attachments'] && activity['attachments'].length > 0 && (
                        <div className="activity-attachments" style={{ marginTop: '10px' }}>
                            <AttachmentList
                                attachments={activity['attachments']}
                                showUploadedBy={false}
                                enableActions={false}
                            />
                        </div>
                    )}
                </div>
            </AccordionItemPanel>
        </>
    );
};

export default Meeting;